export default __webpack_public_path__ + "static/media/Data.4fbf70d5.svg";